import { AppBar, Box, Button, IconButton, Toolbar, Typography } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from "react-router-dom";

interface Props {
  backText: string;
  title?: string;
  children?: any;
}

export const TopAppBar = (props: Props) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mt: 5 }}>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIosIcon></ArrowBackIosIcon>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {props.backText}
            </Typography>
          </IconButton>
          <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
            {props.title ?? ''}
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

